import { format, startOfDay, endOfDay, isToday } from "date-fns";

interface IDateFormatProps {
  type: "date" | "datetime" | "monthDay" | "date-special" | "ISO";
}
interface IGetTypedDateProps {
  date: Date;
  type?: "start" | "end";
}

export const dateFormat = (
  date: Date | string,
  opt: IDateFormatProps,
): string | null => {
  let localDate = date;
  if (!validateDate(date)) {
    localDate = new Date();
  }
  switch (opt.type) {
    case "date":
      return format(new Date(localDate), "dd.MM.yyyy");
    case "date-special":
      return format(new Date(localDate), "yyyy-MM-dd");
    case "monthDay":
      return format(new Date(localDate), "MM-dd");
    case "datetime":
      return format(new Date(localDate), "dd.MM.yyyy hh:mm:ss");
    case "ISO":
      return format(new Date(localDate), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");
  }
};

export function validateDate(input: any) {
  let date: Date;
  if (input instanceof Date) {
    if (input.toString() === "Invalid Date") return false;
    date = input;
  } else if (typeof input === "string" || typeof input === "number") {
    date = new Date(input);
  } else {
    return false;
  }

  return !isNaN(date?.getTime());
}

// Возвращает по type начало либо конец дня.
export const getTypedDate = ({ date, type }: IGetTypedDateProps): string => {
  let resultDate: Date;
  if (type === "end") {
    resultDate = isToday(date) ? new Date() : endOfDay(date);
  } else {
    resultDate = startOfDay(date);
  }
  return format(resultDate, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");
};
